import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { CertificatesService } from "../../services/certificates.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { CommonService } from "src/app/core/services/common.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { Certificates } from "../../models/certificatesMailBox";
import { ListValueService } from "src/app/core/services/list-value.service";
import { AdvancedFiltersService } from "src/app/core/services/advancedFilters.service";
import { StatesPetitionsService } from "src/app/core/services/states-petitions.service";
import { TokenService } from "src/app/core/services/token.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { TableComponent } from "src/app/shared/table/table.component";
import { AppConstants } from "src/app/constants/app.constants";
import { ConvertToPDFService } from "src/app/core/services/convertToPDF.service";
import { dtoPasoAFI } from "src/app/core/models/convertToPDF.model";
import {
  Options,
  OptionsOutTable,
} from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-mailbox",
  templateUrl: "./list-mailbox.component.html",
  styleUrls: ["./list-mailbox.component.scss"],
})
export class ListMailboxComponent implements OnInit {
  @ViewChild("outTable") filtersOutTable: FiltersComponent;
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("table") table: TableComponent;
  certificatesList;
  filtersTable: string;
  filtersTableJSON;
  filtersSearch = "";
  filterList = FilterConstants.certificatesMailBox;
  tableList = TableConstants.certificatesMailBox;
  routing = RoutingConstants.certificatesMailBox;
  public options: Options;
  filterListOutTable = FilterConstants.certificatesMailBoxOutTable;
  filtersSearchOutTable = "";
  public optionsFiltersOutTable: OptionsOutTable = {
    isOutTable: true,
    showFilters: false,
    style: { "min-width": "1135px" },
    showCheckbox: false,
  };
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  certificatesLoaded: boolean = false;
  canSignCertificate: boolean = false;
  showTableFilter: boolean = false;
  showFiltersOut: boolean = false;
  showFilterButtons: boolean = false;
  loadChangeFI = {
    loadOD: false,
    loadOther: false,
  };

  constructor(
    private certificatesService: CertificatesService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private listValueService: ListValueService,
    private sweetAlertService: SweetAlertService,
    private advancedFiltersService: AdvancedFiltersService,
    private statesPetitionsService: StatesPetitionsService,
    private tokenService: TokenService,
    private convertToPDFService: ConvertToPDFService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "peCreacion",
      ScreenConstants.certificates.mailBoxCertificates
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );

    this.canSignCertificate =
      this.tokenService.hasRole(AppConstants.roles.RHOMOLOG) &&
      this.tokenService.hasExpirationCertificate() &&
      !this.tokenService.validateExpiratedCertificate().expired;

    this.options = this.canSignCertificate
      ? TableConstants.NotShowCreateDeleteArrowUpDownAndShowCheckbox
      : TableConstants.NotShowCreateDeleteAndArrowUpDown;

    this.options.style = { "min-width": "1100px" };

    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
    this.filtersSearchOutTable =
      this.filtersTableStateService.composeFiltersOutTable(
        this.filterListOutTable
      );
  }

  ngOnInit(): void {
    this.getList();
    this.getFiltersByUser();
    this.getEstadosList();
    this.getAnalystList();
    this.getCertificateList();
    this.getBrandsList();
    this.getTiposdeVehiculoList();
    this.getActivedTemplates();
    this.getReformsList();
  }

  getList() {
    let filters = this.commonService.concatThreeFilters(
      this.filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    if (!this.sweetAlertService.anyStepsQueue()) {
      this.sweetAlertService.sweetAlertLoading();
    } else {
      this.sweetAlertService.showSwalQueue();
    }

    this.certificatesService.getCertificatesMailBoxList(filters).subscribe(
      (data) => {
        this.certificatesList = data.content.map((e) =>
          Certificates.certificateFromJson(e)
        );
        this.numPages = data.totalPages == 0 ? 1 : data.totalPages;
        this.numElements = data.numberOfElements;
        this.totalElements = data.totalElements;
        this.certificatesLoaded = true;
        if (!this.sweetAlertService.anyStepsQueue()) {
          this.sweetAlertService.sweetAlertClose();
        }
        this.sweetAlertService.resetStepsQueue();
        if (data.content && data.content.length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.getList();
  }

  getAnalystList() {
    this.listValueService.listaAnalistasActivos().subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Analista");
        data.sort(function (a, b) {
          if (a.usuarioId.toUpperCase() < b.usuarioId.toUpperCase()) {
            return -1;
          }
          if (a.usuarioId.toUpperCase() > b.usuarioId.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        this.filterList[pos]["selectorConf"].dataList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getBrandsList() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Marca");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getReformsList() {
    this.listValueService.listReformsPadre().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Reforma"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList =
          this.sortReforma(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  sortReforma(data) {
    return data.sort(function (a, b) {
      var result;

      a = a.reId.split(".");
      b = b.reId.split(".");

      while (a.length) {
        result = a.shift() - (b.shift() || 0);

        if (result) {
          return result;
        }
      }

      return -b.length;
    });
  }

  getTiposdeVehiculoList() {
    this.listValueService.listTipoVehiculo().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo homologado"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getActivedTemplates() {
    this.listValueService.listaPlatillasActivas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Plantilla utilizada"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCertificateList() {
    this.listValueService.listCertificates("1", "true").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Certificado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getEstadosList() {
    this.listValueService.listEstadosByScreen("ES_BUZON_CERT").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Estado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersOutTable.filtersSelectorSearch = [];
        this.filtersOutTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        this.filtersOutTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersSearchOutTable = this.filtersOutTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          if (!this.showFiltersOut) {
            this.showFilterButtons = false;
          }
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  toggleFilterButtons(item: boolean) {
    this.showFiltersOut = item;
    if (this.showFiltersOut) {
      this.showFilterButtons = true;
    } else if (!this.showTableFilter) {
      this.showFilterButtons = false;
    }
  }

  getFiltersByUser() {
    this.advancedFiltersService
      .getAdvancedFiltersByUser("CERTIFICADO")
      .subscribe(
        (data) => {
          this.filterListOutTable =
            this.advancedFiltersService.renderFiltersOut(
              data,
              this.filterListOutTable
            );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  signCertificates() {
    let certificatesOD = [];
    this.table.checkedElementListData.forEach((cert) => {
      if (cert.tipoCertificado === "OD") certificatesOD.push(cert.id);
    });
    let otherCertificates = [];
    this.table.checkedElementListData.forEach((cert) => {
      if (cert.tipoCertificado !== "OD") otherCertificates.push(cert.id);
    });

    if (this.table.checkedElementList.length == 0) {
      let message = this.translateService.instant(
        "messages.changeStates.anyElementSelected"
      );
      this.toastrAlertService.toastrWarning(message);
    } else {
      let message = this.translateService.instant(
        "messages.changeStates.FISelectedElements"
      );
      this.toastrAlertService.toastrWarning(message);
      this.sweetAlertService.sweetAlertLoading();
      if (certificatesOD.length > 0) {
        this.changeToFIODCertificates(certificatesOD);
      } else {
        this.loadChangeFI.loadOD = true;
      }
      if (otherCertificates.length > 0) {
        this.changeToFIOtherCertificates(otherCertificates);
      } else {
        this.loadChangeFI.loadOther = true;
      }
    }
  }

  private changeToFIODCertificates(certificates: string[]) {
    this.loadChangeFI.loadOD = true;
    if (this.loadChangeFI.loadOther) {
      this.sweetAlertService.sweetAlertClose();
    }
    this.changeStateToFISended();

    this.statesPetitionsService
      .chanteToFICertificatesOD(certificates)
      .subscribe(
        (data) => {
          if (this.loadChangeFI.loadOD && this.loadChangeFI.loadOther) {
            this.loadChangeFI.loadOther = false;
            this.loadChangeFI.loadOD = false;
            this.sweetAlertService.sweetAlertClose();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  private changeToFIOtherCertificates(certificates: string[]) {
    this.statesPetitionsService
      .previousStepToChangeToFI(certificates)
      .subscribe(
        (data) => {
          this.convertPDF(data);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  private async convertPDF(peticiones: dtoPasoAFI[]) {
    const files = await Promise.all(
      peticiones.map((peticion) => this.convertPasoPrevioDtoToPdf(peticion))
    );
    console.log(
      "Se han generado [" +
        files.length +
        "] archivos PDF de las [" +
        peticiones.length +
        "] solicitudes."
    );
    this.changeStateToFI(peticiones, files);
  }

  private async convertPasoPrevioDtoToPdf(peticion: dtoPasoAFI) {
    console.log("Convirtiendo en PDF el certificado", peticion.solicitudId);
    const img = await this.convertToPDFService.getImg(peticion.marca);
    this.convertToPDFService.setLoadedFooterAndHeader();
    const regionCpeticionario =
      await this.convertToPDFService.getRegionByConcesionaire(
        peticion.peCpeticionario
      );
    let marca =
      regionCpeticionario === "CANARIAS" ? "CANARIAS" : peticion.marca;
    const data = await this.convertToPDFService.previewPDF(
      peticion.contenido,
      peticion.solicitudId,
      peticion.cve,
      "FI",
      peticion.tipoCertificado,
      "return",
      peticion.revisor,
      marca,
      img,
      peticion.marca
    );
    console.log(
      "Certificado",
      peticion.solicitudId,
      "convertido a PDF. Obteniendo blob..."
    );
    return await this.pdfMakeResultToBlob(data);
  }

  private async pdfMakeResultToBlob(pdfMakeResult) {
    return new Promise((resolve, reject) => {
      console.log("Obtenido blob después de haber construido el PDF.");
      pdfMakeResult.getBlob((blob) => resolve(blob));
    });
  }

  private changeStateToFI(dtoList: dtoPasoAFI[], files: any[]) {
    this.loadChangeFI.loadOther = true;
    if (this.loadChangeFI.loadOD) {
      this.sweetAlertService.sweetAlertClose();
    }
    this.changeStateToFISended();
    this.statesPetitionsService
      .changeToFICertificates(dtoList, files)
      .subscribe(
        (data) => {
          if (this.loadChangeFI.loadOD && this.loadChangeFI.loadOther) {
            this.loadChangeFI.loadOther = false;
            this.loadChangeFI.loadOD = false;
            this.sweetAlertService.sweetAlertClose();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  private changeStateToFISended() {
    this.table.checkedElementList = [];
    this.table.checkedElementListData = [];
  }

  public signAllCertificatesAtCR() {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService.changeToFIAllCertificatesAtCR().subscribe(
      (data) => {
        if (data.length === 0) {
          let message = this.translateService.instant(
            "messages.changeStates.NoAtCR"
          );
          this.toastrAlertService.toastrWarning(message);
          this.sweetAlertService.sweetAlertClose();
        } else {
          let otherCertificates = data.filter((cert) => cert.contenido != null);
          let odCertificates = data
            .filter((cert) => cert.contenido === null)
            .map((cert) => cert.solicitudId);
          if (odCertificates.length > 0) {
            this.changeToFIODCertificates(odCertificates);
          } else {
            this.loadChangeFI.loadOD = true;
          }
          if (otherCertificates.length > 0) {
            this.convertPDF(otherCertificates);
          } else {
            this.loadChangeFI.loadOther = true;
          }
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
